// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tabs__body{background:transparent}.tabs__content{background:#fff;padding:18px 47px 0;margin-bottom:30px}@media screen and (max-width:768px){.tabs__content{padding:18px 20px 0}}", ""]);
// Exports
module.exports = exports;
